import { colors } from 'fitify-ui'
import { typographyStyles } from 'fitify-ui/src/typography/generated/Typography'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledPopularityCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-radius: 10px;
  background: ${colors.White};
  gap: 12px;

  ${phone(css`
    padding: 8px 12px;
    gap: 10px;
  `)};
`

export const StyledPopularityLeft = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`

export const StyledPopularityLabel = styled.div<{ $isTrendUp: boolean }>`
  display: inline-flex;
  align-items: center;
  color: ${colors.Gray500};
  gap: 5px;
  ${typographyStyles('Special/Label 10 Uppercase')}

  &::before {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ $isTrendUp }) =>
      $isTrendUp ? colors.Green500 : colors.Red400};
    content: '';
  }
`

export const StyledPopularityValue = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
`

export const StyledPopularityRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
`

export const StyledBarChart = styled.div`
  display: flex;
  height: 28px;
  align-items: flex-end;
  gap: 3px;

  ${phone(css`
    height: 24px;
  `)};
`

export const StyledBar = styled.div<{
  $height: number
  $index: number
  $isTrendUp: boolean
}>`
  width: 10px;
  height: ${({ $height }) => $height}%;
  min-height: 4px;
  border-radius: 2px;
  background: linear-gradient(
    to top,
    ${({ $isTrendUp }) => ($isTrendUp ? colors.Blue200 : colors.Red200)},
    ${({ $index, $isTrendUp }) =>
      $isTrendUp
        ? $index >= 6
          ? colors.Green400
          : colors.Blue400
        : $index >= 6
          ? colors.Red400
          : colors.Orange300}
  );
  opacity: ${({ $index }) => 0.35 + $index * 0.09};

  ${phone(css`
    width: 8px;
  `)};
`
